<script>
import {Message} from "element-ui";
import {addOrUpdateTrigger, delTrigger, sensorTypeList, triggerList} from "@/api/system";

export default {
  name: 'SensorTrigger',
  data() {
    return {
      visible: false,
      sensorId : null,
      sensorTypeId : null,
      current : 1,
      pageSize: 10,
      total : 0,
      sensorTriggers: [],
      // 表单数据
      form: {},
      // 表单弹窗可见性
      formVisible: false,
      // 表单标题
      formTitle: '新增传感器触发器',
      // 告警级别枚举
      alertLevels: [
        { value: 1, label: '紧急告警', code: 'EMERGENCY_ALERT' },
        { value: 2, label: '重要告警', code: 'IMPORTANT_ALERT' },
        { value: 3, label: '一般告警', code: 'GENERAL_ALERT' },
        { value: 4, label: '提示告警', code: 'PROMPT_ALERT' },
        { value: 5, label: '低风险告警', code: 'LOW_RISK_ALERT' },
        { value: 6, label: '高风险告警', code: 'HIGHT_RISK_ALERT' }
      ],
      // 表单验证规则
      rules: {
        levelId: [
          { required: true, message: '请输入级别ID', trigger: 'blur' }
        ],
        expression: [
          { required: true, message: '请输入表达式', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
  },
  methods: {

    handleOpen(sensorId) {
      if (!sensorId){
        Message.error('传感器id丢失')
         return;
      }
      this.sensorId = sensorId;
      this.visible = true
      this.fetchList();
    },
    handleTypeOpen(sensorTypeId) {
      if (!sensorTypeId){
        Message.error('传感器类型id丢失')
         return;
      }
      this.sensorTypeId = sensorTypeId;
      this.visible = true
      this.fetchList();
    },
    handleClose() {
      this.visible = false
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.current = 1;
      this.fetchList()
    },
    handleCurrentChange(val) {
      this.current = val;
      this.fetchList()
    },
    clearList(){
      this.current = 1
      this.officeList = []
    },
    async fetchList(){
      const param = {
        current : this.current,
        size : this.pageSize,
        filter : [],
        sorted : [],
      }
      if (this.sensorId){
        param.filter.push({
          name : 'sensorId',
          value : this.sensorId,
          type : 'EQ'
        })
      }
      if (this.sensorTypeId){
        param.filter.push({
          name : 'sensorTypeId',
          value : this.sensorTypeId,
          type : 'EQ'
        })
      }
      const resp = await triggerList(param);
      if (resp && resp.code === '0000'){
        this.sensorTriggers = resp.result.records;
        this.total = resp.result.total;
      }
    },

    // 打开新增表单
    openAddForm() {
      this.formTitle = '新增传感器触发器';
      this.form = {
        id: null,
        levelId: null,
        expression: ''
      };
      this.formVisible = true;
    },

    // 打开编辑表单
    openEditForm(row) {
      this.formTitle = '编辑传感器触发器';
      this.form = row;
      this.formVisible = true;
    },

    // 关闭表单弹窗
    closeForm() {
      this.formVisible = false;
    },

    // 提交表单
    submitForm() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          try {
            // 构造提交参数
            const param = {
              ...this.form,
              sensorTypeId: this.sensorTypeId
            };

            console.log('提交参数:', param);

            const resp = await addOrUpdateTrigger(param);
            if (resp && resp.code === '0000') {
              Message.success('保存成功');
              this.formVisible = false;
              this.fetchList();
            }
          } catch (error) {
            console.error('保存失败:', error);
            Message.error('保存失败');
          }
        }
      });
    },

    // 删除传感器触发器
    deleteSensorTrigger(row) {
      this.$confirm('此操作将永久删除该传感器触发器, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const resp = await delTrigger(row.id);
          if (resp && resp.code === '0000') {
            Message.success('删除成功');
            this.fetchList();
          }
        } catch (error) {
          console.error('删除失败:', error);
          Message.error('删除失败');
        }
      }).catch(() => {
        // 用户取消删除
      });
    },

    // 根据级别ID获取标签
    getAlertLevelLabel(levelId) {
      const level = this.alertLevels.find(item => item.value === levelId);
      return level ? level.label : levelId;
    },


    // 拼接占位符
    appendValueExpression(value) {
      if (value){
        this.form.expression = (this.form.expression || '') + ' ' + value + ' '
      }else {
        this.form.expression = (this.form.expression || '') + ' #value '
      }
    },

  }
}

</script>

<template>
  <div>
    <el-drawer
        title="传感器触发器"
        :visible.sync="visible"
        direction="btt"
        size="70vh"
        :with-header="false"
    >
      <el-card shadow="never">
        <!-- 新增按钮 -->
        <div style="display: flex; justify-content: flex-end; margin-bottom: 16px;">
          <el-button v-if="sensorTypeId" type="primary" size="small" @click="openAddForm">新增传感器触发器</el-button>
        </div>

        <el-table :data="sensorTriggers" border stripe highlight-current-row>
          <el-table-column prop="levelId" label="级别ID">
            <template slot-scope="scope">
              {{ getAlertLevelLabel(scope.row.levelId) }}
            </template>
          </el-table-column>
          <el-table-column prop="symbol" label="符号" v-if="sensorId" />
          <el-table-column prop="value" label="值" v-if="sensorId" />
          <el-table-column prop="expression" label="表达式" />
          <el-table-column label="操作" width="180" v-if="sensorTypeId" >
            <template slot-scope="scope">
              <el-button size="mini" type="primary" @click="openEditForm(scope.row)">编辑</el-button>
              <el-button size="mini" type="danger" @click="deleteSensorTrigger(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div style="display: flex; justify-content: flex-end; width: 100%; margin-top: 16px;">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                         :current-page="current" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                         layout="total, sizes, prev, pager, next, jumper" :total="total"
                         class="pagination"></el-pagination>
        </div>
      </el-card>
    </el-drawer>

    <!-- 新增/编辑表单弹窗 -->
    <el-dialog :title="formTitle" :visible.sync="formVisible" width="600px">
      <el-form ref="formRef" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="级别ID" prop="levelId">
          <el-select v-model="form.levelId" placeholder="请选择级别ID">
            <el-option
                v-for="level in alertLevels"
                :key="level.value"
                :label="level.label"
                :value="level.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="占位符">
          <el-tag><span @click="appendValueExpression(null)" style="cursor: pointer">#value</span></el-tag>
        </el-form-item>

        <el-form-item label="表达式" prop="expression">
          <el-input v-model="form.expression" placeholder="请输入表达式" type="text">
            <div slot="suffix">
              <el-popover placement="bottom-end" trigger="click">
                <div style="display: flex;flex-direction: column;gap: 10px;">
                  <div style="display: flex; gap: 3px;" class="expression-helper">
                    <el-tag @click="appendValueExpression('>')">大于</el-tag>
                    <el-tag @click="appendValueExpression('>=')">大于等于</el-tag>
                    <el-tag @click="appendValueExpression('=')">等于</el-tag>
                    <el-tag @click="appendValueExpression('!=')">不等于</el-tag>
                    <el-tag @click="appendValueExpression('<')">小于</el-tag>
                    <el-tag @click="appendValueExpression('<=')">小于等于</el-tag>
                  </div>
                  <div style="display: flex;gap: 10px;">
                    <el-tag @click="appendValueExpression('&&')">且</el-tag>
                    <el-tag @click="appendValueExpression('||')">或</el-tag>
                  </div>
                </div>
                <el-button type="text" size="mini" slot="reference">辅助工具</el-button>
              </el-popover>
            </div>
          </el-input>
        </el-form-item>

      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="closeForm">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<style scoped>
.expression-helper .el-tag {
  cursor: pointer !important;
}
</style>
